import React from 'react';

const Logo = ({ size = 'medium', className = '' }) => {
  const sizes = {
    small: { width: '120px', height: 'auto' },
    medium: { width: '180px', height: 'auto' },
    large: { width: '240px', height: 'auto' },
    xlarge: { width: '300px', height: 'auto' }
  };

  const sizeStyle = sizes[size] || sizes.medium;

  return (
    <div className={`bekaj-logo ${className}`} style={{ display: 'inline-block' }}>
      <img
        src="https://customer-assets.emergentagent.com/job_3ff79c7f-4709-47cc-aaf0-9ed0eeda092d/artifacts/teylvaz3_Bildschirmfoto%202026-01-26%20um%203.41.34%E2%80%AFPM.png"
        alt="BEKAJ-BAU Logo"
        style={{
          width: sizeStyle.width,
          height: sizeStyle.height,
          objectFit: 'contain',
          display: 'block'
        }}
        loading="lazy"
      />
    </div>
  );
};

export default Logo;